import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dash',
    pathMatch: 'full'
  },
  {
    path: 'dash',
    loadChildren: './pages/home/home.module#HomePageModule',
    canActivate: [AuthGuard],
  },
  {
    path: 'offres', loadChildren: './pages/offres/offres.module#OffresPageModule',
    canActivate: [AuthGuard],
    data: {
      meta: {
        can: ['MANAGE_SETTINGS', 'VIEW_SETTINGS']
      }
    }
  },

  { path: 'my-cvs', loadChildren: './pages/my-cvs/my-cvs.module#MyCvsPageModule', canActivate: [AuthGuard], },
  {
    path: 'my-candidatutes', loadChildren: './pages/my-candidatutes/my-candidatutes.module#MyCandidatutesPageModule',
    canActivate: [AuthGuard],
  },
  { path: 'stages', loadChildren: './pages/stages/stages.module#StagesPageModule', canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
